import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

import { CharacterService } from '../../../_services/index';

import * as uuid from 'uuid';

@Component({
    selector: 'ngx-character-edit-modal',
    templateUrl: 'character-edit-modal.component.html',
    styleUrls: ['character-edit-modal.component.scss'],
    standalone: false
})
export class CharacterEditModalComponent {

  originalModel;

  _model;
  istemplate = false;
  customObject
  @Input() set model(model){
    this._model = {...model};
    this.istemplate = model.collectionPath.includes('template')
    this.originalModel = model;
  };

  @Input() languages;
  @Input() templateId;
  @Input() gameId;
  @Input() game;

  currentMood;

  constructor(protected ref: NbDialogRef<CharacterEditModalComponent>,
    public characterService: CharacterService) {}

  async imageUpdated(data){
    if(data){
      this._model.fileURL = data.fileURL;
      this._model.filePath = data.filePath;
      this._model.lastUpdate = data.lastUpdate;
      await this.characterService.updateCharacter(this._model, {fileURL:data.fileURL, filePath:data.filePath, lastUpdate:data.lastUpdate});
    }
  }

  async moodImageUpdated(data){
    this.currentMood.fileURL = data.fileURL;
    this.currentMood.filePath = data.filePath;
    this.currentMood.lastUpdate = data.lastUpdate;
    await this.characterService.updateCharacter(this._model, {moods: this._model.moods});
  }

  cancel() {
    this.ref.close();
  }

  deletePicture(lang){
    if(!lang) this._model.pictureUrl = ''
    else {
      this._model.objectPic[lang] = {}
    }
  }

  editMood(mood){
    if(!mood.languageTtsVoiceId){
      mood.languageTtsVoiceId = {};
    }
    this.currentMood = mood;
  }

  addMood(){
    if(!this._model.moods){
      this._model.moods = [];
    }
    this._model.moods.push({
      id: uuid.v4(),
      name: ''
    });
  }

  async deleteMood(index){
    this._model.moods.splice(index, 1);
    await this.characterService.updateCharacter(this._model, {moods: this._model.moods});
  }

  async changePosition(old_index, new_index){
    let mood1 = this._model.moods[old_index];
    this._model.moods[old_index] = this._model.moods[new_index];
    this._model.moods[new_index] = mood1;
    await this.characterService.updateCharacter(this._model, {moods: this._model.moods});
  }

  async save() {
    //this.originalModel = this._model;
    //Object.assign(this.originalModel, this._model);
    console.log('Save character:'+JSON.stringify(this._model));
    if(this._model.id){
      await this.characterService.updateCharacter(this._model, {...this._model});
    }
    else{
      console.log('create object:'+this._model.collectionPath);
      if(this._model.collectionPath.indexOf('games/')>=0){
        this._model.scope = 'game';
      }
      await this.characterService.addCharacter(this._model); 
    }
    this.ref.close(this.originalModel);
  }
}
